import { useCallback, useMemo } from 'react';
import useAppointmentEvents from '@hooks/useAppointmentEvents';
import type { Appointment } from 'vl-common/src/schemas/shared';
import { useTwilioWS } from './twilioWS';

const useAppointmentGrabbed = (appointment: Appointment) => {
  // require calling useTwilioWS twice to use close in the control message
  const { close } = useTwilioWS(appointment);
  const { close: closeEventsWS } = useAppointmentEvents(appointment);
  // track status and disconnect messages from the other party
  const onControlMessage = useCallback(
    (msg: object) => {
      if ('clinicianChangedFrom' in msg && 'clinicianChangedTo' in msg) {
        closeEventsWS?.();
        close();
      }
    },
    [close, closeEventsWS]
  );
  useTwilioWS(
    appointment,
    useMemo(() => ({ onControlMessage }), [onControlMessage])
  );

  return useMemo(() => {}, []);
};

export default useAppointmentGrabbed;
